iconViewContainer = document.getElementById("icon-view-container")


async function viewIcon(icon) {
    console.log("viewing icon")
    return new Promise((resolve) => {
        iconImage = document.createElement("img")
        iconImage.src = icon.file
        iconImage.classList.add("icon-image")
        iconViewContainer.innerHTML = ""
        iconViewContainer.appendChild(iconImage)
        setTimeout(() => {
            iconViewContainer.removeChild(iconImage)
            console.log("hiding viewed icon")
            setTimeout(() => {
                resolve()
            }, MILLISECONDS_BETWEEN_ICONS)
            
        }, MILLISECONDS_PER_ICON)
    })
}


async function viewRule(rule) {
	return new Promise((resolve) => {
        iconViewContainer.innerHTML = `<h2>${rule.name}</h2> <p>Regel: ${rule.description} </p>`
        setTimeout(() => {     
            resolve()
        }, 4000)
    })
}


function removeIcon() {
    console.log("removing icon")
    existingIconImages = document.getElementsByClassName("icon-image")
    
}



function viewUserInteractionButtons() {
    userInteractionButtons = document.getElementById("user-interaction")
    userInteractionButtons.classList.remove("hidden")
}